import '../styles/Prelude.scss';

import { Stack } from '@whistler-ui/k2/components/Stack';
import { Heading, Paragraph } from '@whistler-ui/k2/components/Typography';
import { useClassHelper } from '@whistler-ui/k2/hooks';
import { CSSProperties } from 'react';

import { useRenderIf } from '../../../hooks/useRenderIf';
import { useThemeStore } from '../../../store/theme';

const componentName = 'p-Prelude';

export function Prelude() {
  const { config } = useThemeStore();
  const c = useClassHelper(componentName);
  const { isCSG } = useRenderIf();

  const headerImage = config.assets.entitlementsGetStarted;

  const style = {
    '--prelude-top-banner-background': isCSG
      ? `linear-gradient(
      90deg,
      var(--color-brand-secondary-900) 0%,
      var(--color-brand-primary) 100%
    )`
      : `url(${headerImage})`,
  } as CSSProperties;

  return (
    <section className={c('base')} style={style}>
      <Stack
        direction="column"
        gap={8}
        className="px-16 py-10 lg:px-32 lg:py-12"
      >
        <Heading level={1} className="!text-[2rem] !leading-[40px]">
          Welcome to the {config.i18n.variables.productName} Developer Portal
        </Heading>
        <Stack direction="column" gap={3}>
          <Paragraph>
            Before you get started, this short guide outlines everything you
            need to know for an easy and painless deployment of your
            Entitlements solution. You are advised to read all the sections
            carefully as there are a few critically important points to consider
            during your onboarding journey.
          </Paragraph>
          <Paragraph>
            This guide may be accessed at any time from the Portal Dashboard.
          </Paragraph>
        </Stack>
      </Stack>
    </section>
  );
}
